import { useState } from 'react';
import { PromptConfirmItemType } from '../types';

export type PromptModalType = PromptConfirmItemType & { advancedPrompt?: string };

export default function usePromptModal({
  defaultPromptInfo,
}: {
  defaultPromptInfo?: PromptModalType;
}) {
  const [visible, setVisible] = useState(false);
  const [promptInfo, setPromptInfo] = useState<PromptModalType | undefined>(
    defaultPromptInfo,
  );

  const toggleVisible = (value = !visible) => {
    setVisible(value);
  };

  return {
    setPromptInfo,
    promptInfo,
    visible,
    toggleVisible,
  };
}
